import { useCallback, useSyncExternalStore } from 'react';
const initialState = {
    active: false,
    saved: false,
    selectedFunds: [],
    mode: 'multi',
    ignoreFunds: [],
};
let state = initialState;
const listeners = new Set();
function emit() {
    listeners.forEach((l) => l());
}
function subscribe(listener) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}
export function getSnapshot() {
    return state;
}
export function activateFundPicker(existingFunds, options) {
    state = {
        active: true,
        saved: false,
        selectedFunds: [...(existingFunds ?? [])],
        mode: options?.mode ?? 'multi',
        ignoreFunds: [...(options?.ignoreFunds ?? [])],
    };
    emit();
}
export function saveFundPicker() {
    state = { ...state, saved: true };
    emit();
}
export function deactivateFundPicker() {
    state = initialState;
    emit();
}
export function toggleFund(assetId) {
    const exists = state.selectedFunds.some((f) => f === assetId);
    const nextSelectedFunds = 
    // eslint-disable-next-line no-nested-ternary
    state.mode === 'single'
        ? exists
            ? []
            : [assetId]
        : exists
            ? state.selectedFunds.filter((f) => f !== assetId)
            : [assetId, ...state.selectedFunds];
    state = {
        ...state,
        selectedFunds: nextSelectedFunds,
    };
    emit();
}
export function removeFund(assetId) {
    state = {
        ...state,
        selectedFunds: state.selectedFunds.filter((f) => f !== assetId),
    };
    emit();
}
const useFundPickerStore = () => {
    const snapshot = useSyncExternalStore(subscribe, getSnapshot);
    const isFundSelected = useCallback((assetId) => snapshot.selectedFunds.some((f) => f === assetId), [snapshot.selectedFunds]);
    return {
        ...snapshot,
        isFundSelected,
    };
};
export default useFundPickerStore;
